// extracted by mini-css-extract-plugin
export default {"leadingVisual":"IssueTypePickerItemLeadingVisual-module__leadingVisual--kFU1h","issueTypeColorIndicator":"IssueTypePickerItemLeadingVisual-module__issueTypeColorIndicator--ht9gH"};